// removed by extract-text-webpack-plugin
module.exports = {"a11yOnly":"global__a11yOnly--3n7m7","focusable":"global__focusable--_TM4N"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/global.css
// module id = ./src/styles/global.css
// module chunks = 4